export default __webpack_public_path__ + "static/media/CapaAddContact.a879d6c5.svg";